import { ref } from "vue";
import { authCookies } from "@/services/cookies";

const STORAGE_KEY = "TASIS:PARENT_CHILD";

const readStoredId = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    const userId = authCookies.getUser()?.id;
    if (!raw || userId == null || String(raw.userId) !== String(userId)) {
      return null;
    }
    return raw.id ?? null;
  } catch {
    return null;
  }
};

export const selectedChildId = ref(readStoredId());
export const children = ref([]);
export const childrenLoading = ref(false);
export const childrenLoaded = ref(false);

export const selectChild = (id) => {
  selectedChildId.value = id;
  const userId = authCookies.getUser()?.id;
  if (userId == null || id == null || id === "") return;
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ userId, id })
  );
};

export const clearParentChild = () => {
  selectedChildId.value = null;
  children.value = [];
  childrenLoaded.value = false;
  localStorage.removeItem(STORAGE_KEY);
};

export const reconcileChild = (items = []) => {
  if (selectedChildId.value == null || selectedChildId.value === "") return;
  const exists = items.some(
    (item) => String(item?.id) === String(selectedChildId.value)
  );
  if (!exists) {
    selectedChildId.value = null;
    localStorage.removeItem(STORAGE_KEY);
  }
};

export const currentChild = () =>
  children.value.find(
    (item) => String(item?.id) === String(selectedChildId.value)
  ) || null;
